<template>
    <locator-container :display-map="false">
        <div class="locator__results">
            <div class="locator__header">
                <h2>Kontakty</h2>
                <locator-search-container/>
            </div>
            <locator-contact-container/>
        </div>
    </locator-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import LocatorSalesPlacesFilter from './SalesPlacesFilter';
    import LocatorContainer from './LocatorContainer';
    import LocatorSearchContainer from './SearchContainer';
    import LocatorContactContainer from './ContactContainer';

    export default {
        name: 'LocatorContacts',
        components: {
            LocatorContactContainer,
            LocatorSearchContainer,
            LocatorContainer,
            LocatorSalesPlacesFilter,
        },
        created() {
            this.setLocatorType('contacts');
        },
        methods: {
            ...mapActions('locator', ['setLocatorType'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/Contacts.vue